import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const ZeroConditionalExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Zero Conditional</h2>
      <p>We use the zero conditional to talk about general truths, facts, rules, and situations that always produce the same result.</p>

      <h3><FaLightbulb /> Structure</h3>
      <p><strong>If + present simple, present simple</strong></p>
      <p>We use the present simple in both the <strong>if-clause</strong> and the main clause.</p>

      <h4>Example structure:</h4>
      <div className="grammar-flex-table">
        {[
          ['If-clause (present simple)', 'Main clause (present simple)'],
          ['If you heat water to 100°C', 'it boils'],
          ['If it rains', 'the ground gets wet'],
          ['If you don\'t water plants', 'they die'],
        ].map(([ifClause, mainClause], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{ifClause}</div>
            <div className="grammar-cell">{mainClause}</div>
          </div>
        ))}
      </div>

      <h3><FaLightbulb /> Examples</h3>
      <ul>
        <li>If you freeze water, it becomes ice.</li>
        <li>If I eat too much sugar, I get a headache.</li>
        <li>If you mix red and white, you get pink.</li>
        <li>If it rains, the match is canceled.</li>
      </ul>

      <h3><FaLightbulb /> Notes</h3>
      <ul>
        <li>The <strong>if-clause</strong> can come first or second in the sentence.</li>
        <li>If the <strong>if-clause</strong> comes first, use a comma.</li>
        <li>If the <strong>if-clause</strong> comes second, no comma is needed.</li>
        <li>We can also use <strong>when</strong> instead of <strong>if</strong> when the result is certain.</li>
      </ul>

      <h4>Examples:</h4>
      <ul>
        <li>If you heat ice, it melts. ✅ (comma after the if-clause)</li>
        <li>Water boils if you heat it to 100°C. ✅ (no comma)</li>
        <li>When water reaches 100°C, it boils. ✅ (using "when" with a certain result)</li>
      </ul>
    </div>
  );
};

export default ZeroConditionalExplanation;
